import React from 'react'
import {
  ApolloClient,
  ApolloProvider,
  createHttpLink,
  from,
} from '@apollo/client'
import { setContext } from '@apollo/client/link/context'
import { getUser } from '../services/auth'
import { cache } from '../cache'
import mixpanel from 'mixpanel-browser'
import { sentryLink } from '../utils/sentryApolloLink'

mixpanel.init(process.env.MIXPANEL_TOKEN, {
  debug: false,
  ignore_dnt: true,
})

const httpLink = createHttpLink({
  uri: process.env.MIDDLE_END_URL,
})

const authLink = setContext((_, { headers }) => {
  const hasToken = !!getUser()?.token
  return {
    headers: {
      ...headers,
      // Respeta un authorization per-request (las ops de transferencia de
      // bolsones y el perfil del bolsón usan el token_api de la empresa en
      // vez del JWT)
      authorization:
        headers?.authorization || (hasToken ? `Bearer ${getUser().token}` : ''),
    },
  }
})

const client = new ApolloClient({
  cache,
  link: from([authLink, sentryLink, httpLink]),
  name: 'admin-push-money',
})

function Apollo({ children }) {
  return <ApolloProvider client={client}>{children}</ApolloProvider>
}
export default Apollo
